import React from 'react';
import { createRoot } from 'react-dom/client';   // ✅ جایگزین ReactDOM
import './i18n';

import App from './App';
import reportWebVitals from './reportWebVitals';

import { Provider } from 'react-redux';
import { configureStore } from './redux/store';

import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { ConfigProvider } from 'antd';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
      cacheTime: 30000, // 30 ثانیه
    },
  },
});

const container:any = document.getElementById('root');
const root = createRoot(container);

root.render(
  <QueryClientProvider client={queryClient}>
    <Provider store={configureStore({})}>
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: '#27ae60',
          },
        }}
      >
        {/* <StrictMode> */}
        <App />
        {/* </StrictMode> */}
      </ConfigProvider>
    </Provider>
    <ReactQueryDevtools />
  </QueryClientProvider>
);

// اگر خواستی لاگ Performance بگیری
reportWebVitals();
